import axios from "axios";
import React, { useEffect, useState } from "react";
import { _serverUrl2 } from "../../../config";
import { failed, loading, removeLoading } from "../../../Utils/Alerts2";
import { BagimsizBolumSiraTable, ComboChart, PieChart } from "../../../Utils/PieCharts";
import ProjectSideBar from "./ProjectSideBar";

export default function HizliTaramaOzet() {
  const [ilceler, setIlceler] = useState([]);
  const [yapiYiliAraligi, setYapiYiliAraligi] = useState([]);
  const [tumAralikDagilimi, setTumAralikDagilimi] = useState([]);
  const [genelBbSayisi, setGenelBbSayisi] = useState([]);
  const [genelInsaatAlani, setGenelInsaatAlani] = useState([]);

  const [oncelik, setOncelik] = useState([]);
  const [oncelikSiraBBTur, setOncelikSiraBBTur] = useState([]);

  const cmbsveriler = async () => {
    await axios
      .get(_serverUrl2 + "/projects/getIlceler")
      .then((res) => {
        setIlceler(res.data.rows);
      })
      .catch((err) => {
        failed(err);
      });

    await axios
      .get(_serverUrl2 + "/projects/getYapiYiliAraligi")
      .then((res) => {
        setYapiYiliAraligi(res.data.rows);
      })
      .catch((err) => {
        failed(err);
      });
  };
  const getInfosFromNode = async (json) => {
    loading();
    // let json = {
    //     ilce_id: 0,
    //     aralik: 0,
    // }

    await axios
      .post(_serverUrl2 + "/projects/KocaeliGeneliTumAralikDagilimi", json)
      .then((res) => {
        console.log(res.data.rows);
        setTumAralikDagilimi(res.data.rows);
      })
      .catch((err) => {
        failed(err);
      });

    await axios
      .post(_serverUrl2 + "/projects/KocaeliGeneliBina_bb_sayisi", json)
      .then((res) => {
        console.log("setGenelBbSayisi", res.data.rows);
        setGenelBbSayisi(res.data.rows);
      })
      .catch((err) => {
        failed(err);
      })
      .finally(() => {
        removeLoading();
      });

    await axios
      .post(_serverUrl2 + "/projects/KocaeliGeneliBina_insaatAlani_sayisi", json)
      .then((res) => {
        console.log("setGenelInsaatAlani", res.data.rows);
        setGenelInsaatAlani(res.data.rows);
      })
      .catch((err) => {
        failed(err);
      })
      .finally(() => {
        removeLoading();
      });

    await axios
      .post(_serverUrl2 + "/projects/KocaeliGeneliDepZeminveOncelikSirasi", json)
      .then((res) => {
        console.log("DDD", res.data.rows);
        setOncelik(res.data.rows);
      })
      .catch(() => {});

    await axios
      .post(_serverUrl2 + "/projects/KocaeliGeneliOncelikSirasiGore_bb_Turleri", json)
      .then((res) => {
        console.log("OncelikSirasiGore_bb_Turleri");
        setOncelikSiraBBTur(res.data.rows);
      })
      .catch((err) => {
        failed(err);
      });
  };

  const onClickAra = async () => {
    loading();
    let json = {
      ilce_id: parseInt(document.getElementById("ilce").value),
      aralik: document.getElementById("yapiYil").value,
    };
    console.log(json);

    getInfosFromNode(json)
      // await axios.post(_serverUrl2 + '/projects/KocaeliGeneliTumAralikDagilimi', json)
      //     .then((res) => {
      //         console.log(res.data.rows)
      //         setTumAralikDagilimi(res.data.rows)
      //     })
      //     .catch((err) => {
      //         failed(err)
      //     })

      // await axios.post(_serverUrl2 + '/projects/KocaeliGeneliBina_bb_sayisi', json)
      //     .then((res) => {
      //         console.log(res.data.rows)
      //         setGenelBbSayisi(res.data.rows)
      //     })
      //     .catch((err) => {
      //         failed(err)
      //     })
      .finally(() => {
        removeLoading();
      });
  };

  useEffect(() => {
    let json = {
      ilce_id: 0,
      aralik: 0,
    };
    cmbsveriler();
    getInfosFromNode(json);
    return () => {};
  }, []);

  return (
    <div className="row" style={{ fontSize: "12px" }}>
      <div className="col-12">
        <ProjectSideBar page={"5"} />
      </div>
      <div className="col-3">
        <select id="ilce" className="form-select form-select-sm">
          {ilceler.map((d) => {
            return <option value={d.ilceid}>{d.ilceadi}</option>;
          })}
        </select>
      </div>

      <div className="col-4">
        <label className="form-control form-control-sm">Yapı Yılı Aralığı</label>
      </div>

      <div className="col-3">
        <select id="yapiYil" className="form-select form-select-sm">
          {yapiYiliAraligi.map((d) => {
            return <option value={d.id}>{d.adi}</option>;
          })}
        </select>
      </div>

      <div className="col-2">
        <button className="blueBtn" onClick={() => onClickAra()}>
          Ara
        </button>
      </div>

      <div className="col-12">&nbsp;</div>

      <div className="col-sm-6" style={{ flexDirection: "columnReverse", minWidth: "300px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
        <div className="textBox" style={{ width: "100%" }}>
          <div className="header">
            <center>
              <h4>
                <b>Puanlama Skalasına Göre Dağılım</b>
              </h4>
            </center>
          </div>
          <PieChart
            data={tumAralikDagilimi.map((d) => {
              return parseInt(d.sayi);
            })}
            label={tumAralikDagilimi.map((d) => {
              return d.oncelik_sirasi;
            })}
            toplam={tumAralikDagilimi.reduce((total, d) => total + parseInt(d.sayi), 0)}
          />
        </div>
      </div>

      <div className="col-sm-6" style={{ flexDirection: "columnReverse", minWidth: "300px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
        <div className="textBox" style={{ width: "100%" }}>
          <div className="header">
            <center>
              <h4>
                <b>Çok Yüksek ve Yüksek Öncelikli Bina Sayısı</b>
              </h4>
            </center>
          </div>
          <PieChart
            data={genelInsaatAlani.map((d) => {
              return parseInt(d.bina_sayisi);
            })}
            label={genelInsaatAlani.map((d) => {
              return d.seviye;
            })}
            toplam={genelInsaatAlani.reduce((total, d) => total + parseInt(d.bina_sayisi), 0)}
          />
        </div>
      </div>

      <div className="col-sm-6" style={{ flexDirection: "columnReverse", minWidth: "300px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
        <div className="textBox" style={{ width: "100%" }}>
          <div className="header">
            <center>
              <h4>
                <b>Çok Yüksek ve Yüksek Öncelikli Bağımsız Bölüm Sayısı</b>
              </h4>
            </center>
          </div>
          <PieChart
            data={genelBbSayisi.map((d) => {
              return parseInt(d.toplam_bb);
            })}
            label={genelBbSayisi.map((d) => {
              return d.seviye;
            })}
            toplam={genelBbSayisi.reduce((total, d) => total + parseInt(d.toplam_bb), 0)}
          />
        </div>
      </div>

      <div className="col-sm-6" style={{ flexDirection: "columnReverse", minWidth: "300px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
        <div className="textBox" style={{ width: "100%" }}>
          <div className="header">
            <center>
              <h4>
                <b>Çok Yüksek ve Yüksek Öncelikli İnşaat Alanı m²</b>
              </h4>
            </center>
          </div>
          <PieChart
            data={genelInsaatAlani.map((d) => {
              return parseInt(d.toplam_taban_alani);
            })}
            label={genelInsaatAlani.map((d) => {
              return d.seviye;
            })}
            toplam={genelInsaatAlani.reduce((total, d) => total + parseInt(d.toplam_taban_alani), 0)}
          />
        </div>
      </div>
      <div className="col-sm-12" style={{ flexDirection: "columnReverse", minWidth: "300px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
        <div className="textBox" style={{ width: "100%" }}>
          <div className="header">
            <center>
              <h4>
                <b>Zemin ve Öncelik Sırası</b>
              </h4>
            </center>
          </div>
          <ComboChart data={oncelik} zeminOncelikIsim={oncelik.map((z) => z.label)} />
        </div>
      </div>
      <div className="col-sm-12" style={{ flexDirection: "columnReverse", minWidth: "300px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
        <div className="textBox" style={{ width: "100%" }}>
          <div className="header">
            <center>
              <h4>
                <b>Önceliğe Göre Bağımsız Bölüm Sıralaması</b>
              </h4>
            </center>
          </div>
          <BagimsizBolumSiraTable data={oncelikSiraBBTur} zeminOncelikIsim={oncelikSiraBBTur.map((d) => d.label)} />
        </div>
      </div>
      <div className="col-sm-12" style={{ flexDirection: "columnReverse", minWidth: "300px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
        <div className="textBox" style={{ width: "100%" }}>
          <div className="header">
            <center>
              <h4>
                <b>Önceliğe Göre Bağımsız Bölüm Sıralaması</b>
              </h4>
            </center>
          </div>
          <ComboChart data={oncelikSiraBBTur} zeminOncelikIsim={oncelikSiraBBTur.map((d) => d.label)} />
        </div>
      </div>
    </div>
  );
}
